export class Transformer {
    configuration;
    constructor(configuration) {
        this.configuration = configuration;
    }
    transform(type) {
        return this.configuration[type.class]?.(type, this);
    }
    static create(configuration) {
        return new Transformer(configuration);
    }
}
//# sourceMappingURL=Transformer.js.map